module.exports = __webpack_public_path__ + "static/media/loader-new.a011389b.svg";